import { Languages } from 'config'
import { EnglishIcon, FrenchIcon, GermanIcon, SpanishIcon } from 'shared/icons'

export const langIcons: Record<Languages, JSX.Element> = {
  [Languages.English]: <EnglishIcon />,
  [Languages.French]: <FrenchIcon />,
  [Languages.German]: <GermanIcon />,
  [Languages.Spanish]: <SpanishIcon />,
}
